export default __webpack_public_path__ + "static/media/Navigation-HD.8caace9d.jpg";